/* eslint-disable camelcase */
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"

import _get from "lodash/get"
import { scroller } from "react-scroll"

import useWindowResize from "@/hooks/useWindowResize"
import style from "@/components/ProductDetail/v3/ProductDetailView/productDetailsView.module.scss"

import {
  closeModalAnalytics,
  getCartItemType,
  getCurrentSkuCouponDiscounts,
  getUserAnalyticsObject,
  isShowAnalyticsEventLoaded,
  pdpTypeFormat,
  preventBodyScroll,
  sanitizeTextForAnalytics,
} from "@/utils/helper"

import { isANYPersona } from "@/constants/"
import { getRequireItems } from "@/components/ProductDetail/v3/productDetailsHelper"

import PageLoader from "@/components/core/PageLoader/PageLoader"
import PdpProgressiveLoader from "@/components/ProductDetail/v2/ProgressiveLoader/PdpProgressiveLoader"
import ImageGallery from "@/components/ImageGallery/v2/ImageGallery"
import ProductDescription from "@/components/ProductDetail/v3/ProductDetailView/ProductDescription"
import ProductBreadcrumb from "@/components/ProductDetail/v3/ProductDetailView/ProductBreadcrumb"
import StickyHead from "@/components/ProductDetail/v3/ProductDetailView/StickyHead"
import { getEventInfo } from "@/components/ProductDetail/v3/analytics"

import { fetchPdpRequiredItems } from "@/store/features/pdpSlice"
import { setPageObject } from "@/store/features/genericSlice"

import toolTipIcon from "@/public/icons/tooltip.svg"
import { formatBundleItems } from "@/utils/product"
import { reorderImageData } from "../helper"

const ProductDetailView = props => {
  const {
    viewLoader = true,
    config = {},
    getReqItemLwData = () => {},
    colorsData = [],
    staticTexts = {},
    badgesProps = {},
    presetConfigObject = {},
    discountedPrice = "",
    price = "",
    productOnStock = "",
    sku = "",
    customerFacingSKU = "",
    isComboSku = false,
    customerBrandName = "",
    disableRatings = false,
    replaceAddToCartCtaLink = "",
    replaceAddToCartCtaLabel = "",
    linkNewTab = false,
    disableEcommerce = false,
    currencySign = "",
    imagesData = [],
    onAddToCart = () => {},
    stickyHeaderProps = {},
    addToCartProps = {},
    onAvailableColor = () => {},
    isRegionSoldOnline = true,
    replaceAddToCart = "",
    assetAccountName = "",
    productCategory = "",
    name = "",
    homePagePath = "",
    desc = "",
    discountPercent = 0,
    superSku = "",
    selectedColor = "",
    businessUnitName = "",
    productSaleable = "",
    productPartnerBuyNow = "",
    productCollectionsName = "",
    globalDiscount = 0,
    cart = {},
    ProductPriceSpiderIncluded_s = "",
    discontinuedProductb = "",
    ProductRequiredAccessoriesGroupsList = [],
    loadShowEvent = "",
    setProductInfo = () => {},
    clickedProductVariant = "",
    removeVariantSelection = () => {},
    requiredItems = [],
    addItemsToCart = () => {},
    discontinuedProduct = false,
    getDiscontinuedProductValue = () => {},
    imageClickCounter = 0,
    updateImageClickCounter = () => {},
    productData = {},
    initialImgAlt = "",
    initialImgUrl = "",
    pdpJson = {},
    waterSenseProduct = [],
    isInstock = false,
    atcLoading = false,
    ctLoading,
    handleBuyNow = () => {},
    setPincode = () => {},
    buyNowLoading = false,
    loadingMessage = "",
    isPdpPropsLoaded,
    upSellData
  } = props

  const dispatch = useDispatch()
  const [sticky, setSticky] = useState(true)
  const [priceTooltip, setPriceTooltip] = useState(false)
  const [showPDPInstallModal, setShowPDPInstallModal] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [installReq, setInstallReq] = useState([])
  const [installReqData, setInstallReqData] = useState([])
  const [reqItemLwData, setReqItemLwData] = useState([])
  const [currentQuantity, setCurrentQuantity] = useState(1)
  const [priceList, setPriceList] = useState()
  const [subTotal, setSubTotal] = useState()
  const [showStickyHeader, setShowStickyHeader] = useState(true)
  const [isMobileOnly, setIsMobileOnly] = useState(false)
  const [installError, setInstallError] = useState(false)
  const [warehouses, setWareHouses] = useState([])
  const [pinCodeError, setPinCodeError] = useState(false)
  const [isOutOfStock, setIsOutOfStock] = useState(null)
  const [installServiceData, setInstallServiceData] = useState({})
  const [isChecked, setIsChecked] = useState(false)
  const [bundleItems, setBundleItems] = useState([])
  const [notifyClicked, setNotifyClicked] = useState(false)
  const addCartContainer = useRef(null)
  const notifyContainer = useRef(null)
  const rightSectionRef = useRef(null)
  const previousSticky = useRef(false)
  const [quantity, setQuantity] = useState(1)
  const [isEtaLoading, setIsEtaLoading] = useState(false)

  const {
    general,
    general: { swatchUrl = "", scene7AccountName = "" } = {},
    plpServletPath,
  } = config || {}
  const isPersonaANY = isANYPersona

  const badgeTxt = badgesProps.isNewProduct
    ? badgesProps.exclusiveBadge
      ? staticTexts.newExclusive
      : staticTexts.new
    : badgesProps.exclusiveBadge
    ? staticTexts.exclusive
    : badgesProps.badgeVal
    ? staticTexts.sale
    : ""

  const [width] = useWindowResize()

  useEffect(() => {
    if (width > 0) {
      setIsMobileOnly(width <= 480)
    }
  }, [width])

  const productAnalyticsData = {
    desc: sanitizeTextForAnalytics(desc),
    discountPrice: discountedPrice,
    discountPriceState:
      discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
    unitPrice: price,
    category: sanitizeTextForAnalytics(productCategory),
    color: sanitizeTextForAnalytics(
      _get(
        colorsData.find(item => item.id === sku),
        "label",
        ""
      )
    ),
    sku: sku,
    name: sanitizeTextForAnalytics(name),
    quantity: currentQuantity,
    image: imagesData[0]?.url,
    stock: productOnStock,
    availability: isInstock ? "in stock" : "out of stock",
    customerFacingSKU:
      customerFacingSKU ||
      (general?.siteName ? general.siteName[0] + "-" + sku : ""),
    skuInitials: customerFacingSKU
      ? customerFacingSKU.split("-")[0] + "-"
      : general?.siteName
      ? general.siteName[0] + "-"
      : "",
    discountName: badgesProps?.badgeVal,
    superSku: superSku,
    selectedColor: sanitizeTextForAnalytics(selectedColor),
    businessUnitName: sanitizeTextForAnalytics(businessUnitName),
    productSaleable: productSaleable,
    brandName: general?.siteName?.toLowerCase(),
    productPartnerBuyNow: productPartnerBuyNow,
    productCollectionsName: sanitizeTextForAnalytics(productCollectionsName),
    globalDiscount: globalDiscount || 0,
  }

  const { productCouponCode, productCoupondiscount } =
    getCurrentSkuCouponDiscounts({
      cart: cart,
      sku: productAnalyticsData.sku,
    })
  const { pdpDesktopImage, pdpMobileImage } = pdpJson
  let waterSenseProductVal = false
  if (waterSenseProduct && waterSenseProduct.length) {
    waterSenseProductVal = waterSenseProduct[0] === "Yes" ? true : false
  }

  const productInfo = {
    description: productAnalyticsData.desc || "n/a",
    frequency: "n/a",
    globalPromotionPrice: productAnalyticsData.globalDiscount
      ? Number(
          (
            productAnalyticsData.unitPrice - productAnalyticsData.globalDiscount
          ).toFixed(2)
        )
      : productAnalyticsData.unitPrice,
    isRecommended: false,
    isSendNow: "n/a",
    isSubscription: false,
    priceState: productAnalyticsData.discountPriceState,
    productBasePrice: productAnalyticsData.unitPrice || "n/a",
    productCategory:
      productAnalyticsData.category ||
      productAnalyticsData.businessUnitName ||
      "n/a",
    productColor: productAnalyticsData.color || "n/a",
    productCoupondiscount: productCoupondiscount,
    productCouponCode: productCouponCode.join("|") || "n/a",
    productID: productAnalyticsData.customerFacingSKU || "n/a",
    productName: productAnalyticsData.name || "n/a",
    productPartnerBuyNow: productAnalyticsData.productPartnerBuyNow,
    productRoom:
      productAnalyticsData.businessUnitName || productAnalyticsData.category,
    productSalePrice: productAnalyticsData.discountPrice
      ? productAnalyticsData.discountPrice
      : productAnalyticsData.unitPrice,
    productSaleable: productAnalyticsData.productSaleable,
    productStatus: productAnalyticsData.stock ? "in stock" : "out of stock",
    productSuperSku: productAnalyticsData.superSku ? true : false,
    productTileName: productAnalyticsData.name || "n/a",
    quantity: productAnalyticsData.quantity || "n/a",
    defaultImageName: productAnalyticsData.image || "n/a",
    ratings: "n/a",
    numberOfReviews: "n/a",
    pdpType: pdpTypeFormat({
      businessUnitName: businessUnitName,
      ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
      discontinuedProductb: discontinuedProductb,
      ProductRequiredAccessoriesGroupsList:
        ProductRequiredAccessoriesGroupsList,
      superSku: superSku,
    }),
    productFindingMethod: "n/a",
    productCollectionsName:
      productAnalyticsData.productCollectionsName ||
      productAnalyticsData.category ||
      "n/a",
    productBrand: productAnalyticsData.brandName,
    globalOffer: productAnalyticsData.discountName || "n/a",
    globalDiscount: productAnalyticsData.discountPrice
      ? productAnalyticsData.globalDiscount
      : 0,
    itemType: getCartItemType(
      productAnalyticsData.category,
      productAnalyticsData.businessUnitName
    ),
    category:
      productAnalyticsData.category ||
      productAnalyticsData.businessUnitName ||
      "n/a",
    waterSenseProduct: waterSenseProductVal,
    productType: productData["BundleList_ss"] ? "VirtualBundleParent" : "n/a",
    ...(!productAnalyticsData.stock && { availability: "out_of_stock" }),
    ...(!productAnalyticsData.stock && {
      errorMessage:
        "This product is currently unavailable. Please check back later.",
    }),
    pincode:
      document.cookie.match("(^|;)\\s*pincode\\s*=\\s*([^;]+)")?.pop() || "",
  }
  window.productInfo = JSON.stringify(productInfo)
  window.pageObj.productInfo = productInfo
  dispatch(setPageObject(true))
  disableEcommerce
    ? (productAnalyticsData.stringProductInfo = JSON.stringify({
        productInfo,
      }))
    : (productAnalyticsData.stringProductInfo = JSON.stringify({
        page: { cart: { cartID: cart?.id } },
        productInfo,
      }))

  const options = { root: null, rootMargin: "0px", threshold: 1.0 }

  useEffect(() => {
    if (installReq.length > 0) {
      getRequireItems(
        installReq,
        discountedPrice,
        price,
        () => setInstallReq(installReq),
        subtotal => setSubTotal(subtotal),
        priceList => setPriceList(priceList),
        cartItem => addItemsToCart(cartItem, false)
      )
    }
  }, [sku])

  let pageLoadAnalyticsTimer

  const clearPageLoadAnalyticsTimer = () => {
    if (pageLoadAnalyticsTimer) {
      clearTimeout(pageLoadAnalyticsTimer)
      pageLoadAnalyticsTimer = undefined
    }
  }

  const addPageLoadAnalytics = () => {
    clearPageLoadAnalyticsTimer()
    if (
      window.pageObj &&
      loadShowEvent &&
      window.adobeDataLayer.length > 0 &&
      !ctLoading
    ) {
      const page = window.pageObj || {}
      const category = window.pageObj?.category || {}
      const pageType = window.pageObj?.category?.pageType || ""
      const siteName = productAnalyticsData.brandName
      const pageInfo = window.pageObj?.pageInfo || {}
      category["subCategory1"] = pageType + ":" + productAnalyticsData.category
      category["subCategory2"] =
        pageType +
        ":" +
        productAnalyticsData.category +
        ":" +
        productAnalyticsData.customerFacingSKU
      category["subCategoryID"] = productAnalyticsData.customerFacingSKU
      category["room"] = productInfo?.productRoom || ""
      if (window.needPdpdata) {
        const { productSubCatergory = "", skuID = "" } = window.needPdpdata
        const { pageInfo: { contentType = "pdp" } = {} } = page
        page.category["subCategoryName"] = productSubCatergory
        page.pageInfo[
          "pageName"
        ] = `${siteName}:${contentType}:${productSubCatergory}:${skuID}`
        category["subCategory1"] = pageType + ":" + productSubCatergory
        category["subCategory2"] =
          pageType +
          ":" +
          productSubCatergory +
          ":" +
          productAnalyticsData.customerFacingSKU
        delete window.needPdpdata
      }
      pageInfo["defaultImage"] = imagesData.length
        ? imagesData[0].assetId || imagesData[0].url
        : "n/a"
      page.category = category
      if (!isShowAnalyticsEventLoaded()) {
        page.user = getUserAnalyticsObject()
        page.productInfo = productInfo
        if (
          (!page.user.gId || page.user.gId === "n/a") &&
          (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")
        ) {
          page.pageInfo = pageInfo
          window.pageObj = page
          window.isShowAnalyticsEvent = true
        } else {
          window.adobeDataLayer.push({
            event: "cmp:show",
            pageInfo,
            productInfo,
            page,
          })
          // delete window.pageObj
          setProductInfo(productAnalyticsData.stringProductInfo)
        }
      }
    } else {
      pageLoadAnalyticsTimer = setTimeout(() => addPageLoadAnalytics(), 500)
    }
  }

  useEffect(() => {
    addPageLoadAnalytics()

    return () => {
      setProductInfo(null)
      clearPageLoadAnalyticsTimer()
      delete window.productInfo
    }
  }, [loadShowEvent])

  useEffect(() => {
    if (clickedProductVariant) {
      // add a click event as use has selected differenct product color/variant
      removeVariantSelection()
      const { adobeDataLayer: { getState } = {} } = window
      const page = (getState && getState("page")) || {}
      page.productInfo = productInfo
      const eventInfo = getEventInfo("color selection", true)
      window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo,
      })
      setProductInfo(productAnalyticsData.stringProductInfo)
    }
  }, [clickedProductVariant])

  /* PDP required items - Must have order SKU's */
  useEffect(() => {
    const fetchRequiredItems = async () => {
      let query = ""
      let lwQuery = ""
      requiredItems.forEach((item, i) => {
        query = query + `"${item}"${i !== requiredItems.length - 1 ? "," : ""}`
        lwQuery += `"${item}" `
      })

      dispatch(fetchPdpRequiredItems(query))
        .unwrap()
        .then(response => {
          setInstallReqData(response)
          getReqItemLwData(lwQuery)
            .unwrap()
            .then(lwData => setReqItemLwData(lwData ?? []))
        })
        .catch(err => {
          console.error("Fetching data failed", err)
        })
    }
    if (requiredItems?.length > 0) {
      fetchRequiredItems()
    }
  }, [requiredItems])

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setSticky(!entry.isIntersecting)
    })
    if (addCartContainer.current) observer.observe(addCartContainer.current)
    return () => {
      if (addCartContainer.current) {
        observer.unobserve(addCartContainer.current)
      }
    }
  }, [addCartContainer, options])
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setSticky(!entry.isIntersecting)
    })
    if (notifyContainer.current) observer.observe(notifyContainer.current)
    return () => {
      if (notifyContainer.current) {
        observer.unobserve(notifyContainer.current)
      }
    }
  }, [notifyContainer, options])

  const onModalClose = () => {
    setShowPDPInstallModal(false)
    preventBodyScroll(false)
  }

  const onInstallCTA = () => {
    setShowPDPInstallModal(true)
    preventBodyScroll(true)
  }

  const handleInfoToolTipHover = e => {
    e.stopPropagation()
    setShowTooltip(true)
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    const eventInfo = {
      clickInternalLinks: "true",
      eventAction: "pdp:product details:info tooltip",
      eventName: "pdp:product details:info tooltip",
      eventType: "navigation",
      internalLinkName: "info tooltip",
      internalLinkPosition: "pdp",
      internalLinkType: "pdp:mouseover",
      internalLinkURL: "n/a",
      internalLinkZoneName: "pdp:product details",
    }
    window.adobeDataLayer.push({
      event: "cmp:click",
      page,
      eventInfo,
      productInfo,
    })
  }

  const handleRemove = i => {
    const priceListItems = []
    let requiredItemsPrice = 0
    let priceLists = 0
    let baseTotal = 0
    let subTotalItem = 0
    let curValue = installReq
    curValue = installReq.filter(f => f.skuid !== i.skuid)
    setInstallReq(curValue)
    const cartItemProduct = []
    if (curValue.length > 0) {
      curValue &&
        curValue.map(currentItem => {
          const product = {}
          product.sku = currentItem.skuid
          const checkQuantity = _get(
            currentItem.colorsData.find(
              requiredItem => requiredItem.id === currentItem.skuid
            ),
            "isOutOfStock",
            false
          )
          product.quantity = !checkQuantity ? 1 : 0
          if (!checkQuantity) {
            cartItemProduct.push(product)
          }
          if (currentItem?.priceData) {
            priceLists =
              _get(
                currentItem.priceData.find(
                  requiredList => requiredList.id === currentItem.skuid
                ),
                "discountedPrice",
                0
              ) > 0
                ? _get(
                    currentItem.priceData.find(
                      requiredList => requiredList.id === currentItem.skuid
                    ),
                    "discountedPrice",
                    0
                  )
                : _get(
                    currentItem.priceData.find(
                      requiredList => requiredList.id === currentItem.skuid
                    ),
                    "price",
                    0
                  )

            priceListItems.push(priceLists)
            if (priceListItems.length >= 0) {
              requiredItemsPrice = priceListItems.reduce((acc, currentItem) => {
                return parseFloat(acc) + parseFloat(currentItem)
              }, 0)
            } else {
              requiredItemsPrice = priceListItems[0]
            }
            baseTotal = discountedPrice > 0 ? discountedPrice : price
            subTotalItem = baseTotal + requiredItemsPrice
            setSubTotal(subTotalItem)
            setPriceList(requiredItemsPrice)
          }
        })
      addItemsToCart(cartItemProduct, false)
    } else {
      addItemsToCart([], false)
    }
  }

  const comparedProductsCount = Number(_get(props, "comparedProductsCount", 0))

  const discontinuedColor = _get(
    colorsData.find(item => item.id === sku),
    "discontinuedColor",
    ""
  )
  let isDiscontinued = false
  let isColorDiscontinued = false

  if (discontinuedProduct) {
    isDiscontinued = true
    getDiscontinuedProductValue(isDiscontinued)
  } else if (discontinuedColor) {
    isDiscontinued = true
    isColorDiscontinued = true
    getDiscontinuedProductValue(isDiscontinued)
  }

  const handleNavChange = (navActive, addToDatalayer = false) => {
    if ((navActive === 4 || addToDatalayer) && window.adobeDataLayer) {
      // adding a click even on Write a review button Requirement#47
      const eventInfo = getEventInfo("write a review", true)
      const { adobeDataLayer: { getState } = {} } = window
      const page = (getState && getState("page")) || {}
      window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo,
      })
      closeModalAnalytics(productAnalyticsData.stringProductInfo)
    }
  }

  const handleQuantityChange = qty => {
    if (qty) {
      setCurrentQuantity(qty)
    }
  }

  const handleScroll = () => {
    const element = document.querySelector(".out-of-stock-description")
    if (element) {
      const offsetPosition = element.getBoundingClientRect().top - 150
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      })
      setNotifyClicked(true)
    }
  }

  const handleSetPriceTooltip = (type, needsToSetState, tooltipContent) => {
    if (needsToSetState) setPriceTooltip(true)
    if (!window.isHoverLoaded) {
      window.isHoverLoaded = true
      setTimeout(() => {
        const { adobeDataLayer: { getState } = {} } = window
        const page = (getState && getState("page")) || {}
        const eventInfo = getEventInfo(type, true, tooltipContent)
        window.adobeDataLayer.push({
          event: "cmp:click",
          eventInfo,
          page,
          productInfo,
        })
        delete window.isHoverLoaded
      }, 1400)
    }
  }

  return (
    <>
      <PageLoader
        loading={atcLoading || buyNowLoading}
        loadingMessage={loadingMessage}
      />
      <StickyHead
        setSticky={setSticky}
        sticky={sticky}
        isDiscontinued={isDiscontinued}
        warehouses={warehouses}
        showStickyHeader={showStickyHeader}
        stickyHeaderProps={stickyHeaderProps}
        discountedPrice={discountedPrice}
        price={price}
        staticTexts={staticTexts}
        onAddToCart={onAddToCart}
        isColorDiscontinued={isColorDiscontinued}
        addToCartProps={addToCartProps}
        productOnStock={productOnStock}
        sku={sku}
        customerFacingSKU={customerFacingSKU}
        isComboSku={isComboSku}
        isBundle={Boolean(productData?.bundleItems?.length)}
        handleScroll={handleScroll}
        onAvailableColor={onAvailableColor}
        isRegionSoldOnline={isRegionSoldOnline}
        productAnalyticsData={productAnalyticsData}
        customerBrandName={customerBrandName}
        replaceAddToCart={replaceAddToCart}
        disableRatings={disableRatings}
        replaceAddToCartCtaLink={replaceAddToCartCtaLink}
        replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
        linkNewTab={linkNewTab}
        disableEcommerce={disableEcommerce}
        currencySign={currencySign}
        swatchUrl={swatchUrl}
        imagesData={imagesData}
        presetConfigObject={presetConfigObject}
        assetAccountName={assetAccountName}
        productPriceSpiderIncluded={ProductPriceSpiderIncluded_s}
        productInfo={productInfo}
        installError={installError}
        pinCodeError={pinCodeError}
        setPinCodeError={setPinCodeError}
        isOutOfStock={isOutOfStock}
        installServiceData={installServiceData}
        setInstallServiceData={setInstallServiceData}
        isChecked={isChecked}
        bundleItems={bundleItems}
        isEtaLoading={isEtaLoading}
        isPdpPropsLoaded={isPdpPropsLoaded}
      />
      {viewLoader ? (
        <PdpProgressiveLoader />
      ) : (
        <div className={style.productDetailsV3Wrapper}>
          <div className="product-detail-page" role="main">
            <div className="container">
              <ProductBreadcrumb
                staticTexts={staticTexts}
                productCategory={productCategory}
                name={name}
                homePagePath={homePagePath}
                plpServletPath={plpServletPath}
                config={config}
                productAnalyticsData={productAnalyticsData}
                productData={productData}
                swatchUrl={swatchUrl}
                imagesData={imagesData}
                width={width}
                presetConfigObject={presetConfigObject}
              />
              <div className="product-overview print-overview">
                <div className="product-detail-page__image-gallery print-overview-left">
                  <div className="product-detail-page__left-sticky">
                    <ImageGallery
                      data={reorderImageData(imagesData)}
                      imageClickCounter={imageClickCounter}
                      updateImageClickCounter={updateImageClickCounter}
                      productInfo={productAnalyticsData.stringProductInfo}
                      page="pdp"
                      staticTexts={staticTexts}
                      presetConfigObject={presetConfigObject}
                      swatchUrl={swatchUrl}
                      assetAccountName={scene7AccountName ?? "PAWEB"}
                      initialImgAlt={initialImgAlt}
                      initialImgUrl={initialImgUrl}
                      pdpDesktopImage={pdpDesktopImage}
                      pdpMobileImage={pdpMobileImage}
                    />
                  </div>
                </div>
                <div className="product-detail-page__content-section print-overview-right">
                  <ProductDescription
                    {...props}
                    ref={{ rightSectionRef, addCartContainer, notifyContainer }}
                    badgeTxt={badgeTxt}
                    isDiscontinued={isDiscontinued}
                    isPersonaANY={isPersonaANY}
                    productInfo={productInfo}
                    priceTooltip={priceTooltip}
                    handleSetPriceTooltip={handleSetPriceTooltip}
                    setPriceTooltip={value => setPriceTooltip(value)}
                    installReq={installReq}
                    productAnalyticsData={productAnalyticsData}
                    onInstallCTA={onInstallCTA}
                    toolTipIcon={toolTipIcon}
                    handleInfoToolTipHover={handleInfoToolTipHover}
                    setShowTooltip={value => setShowTooltip(value)}
                    showTooltip={showTooltip}
                    isMobileOnly={isMobileOnly}
                    handleRemove={handleRemove}
                    priceList={priceList}
                    subTotal={subTotal}
                    getRequireItems={items =>
                      getRequireItems(
                        items,
                        discountedPrice,
                        price,
                        () => setInstallReq(items),
                        subtotal => setSubTotal(subtotal),
                        priceList => setPriceList(priceList),
                        cartItem => addItemsToCart(cartItem, false)
                      )
                    }
                    installReqData={installReqData}
                    reqItemLwData={reqItemLwData}
                    onModalClose={onModalClose}
                    showPDPInstallModal={showPDPInstallModal}
                    handleQuantityChange={handleQuantityChange}
                    comparedProductsCount={comparedProductsCount}
                    isColorDiscontinued={isColorDiscontinued}
                    warehouses={warehouses}
                    setWareHouses={setWareHouses}
                    handleNavChange={navActive => handleNavChange(navActive)}
                    installErrorCallback={error => {
                      setInstallError(error)
                    }}
                    pinCodeError={pinCodeError}
                    setPinCodeError={setPinCodeError}
                    installServiceData={installServiceData}
                    setInstallServiceData={setInstallServiceData}
                    isChecked={isChecked}
                    setIsChecked={setIsChecked}
                    bundleItems={bundleItems}
                    setBundleItems={setBundleItems}
                    quantity={quantity}
                    setQuantity={setQuantity}
                    handleBuyNow={handleBuyNow}
                    setPincode={setPincode}
                    setIsOutOfStock={setIsOutOfStock}
                    isOutOfStock={isOutOfStock}
                    notifyClicked={notifyClicked}
                    setIsEtaLoading={setIsEtaLoading}
                    upSellData={upSellData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ProductDetailView
